import currency from '@/filters/currency';
import javascriptDateFormatter from '@/filters/javascriptDateFormatter';
import unixDateFormatter from '@/filters/unixDateFormatter';
import uppercase from '@/filters/uppercase';
import numberWithCommas from '@/filters/numberWithCommas';

export default {
  install(Vue) {
    Vue.filter('currency', currency);
    Vue.filter('unixDateFormatter', unixDateFormatter);
    Vue.filter('javascriptDateFormatter', javascriptDateFormatter);
    Vue.filter('uppercase', uppercase);
    Vue.filter('numberWithCommas', numberWithCommas);
  },
};
